import { PropsWithChildren, useState } from 'react';
import { Box, Collapse, Divider, IconButton, Tooltip, Typography } from '@mui/material';
import {
  Add as AddIcon,
  ArrowRight as ArrowRightIcon,
  ArrowDropDown as ArrowDropDownIcon,
  Edit as EditIcon,
  Remove as RemoveIcon,
  WarningAmber as WarningAmberIcon,
} from '@mui/icons-material';

type Plan = { invalid?: Record<string, string[]>; create: unknown[]; update: unknown[]; delete: unknown[] };
type Props = { title: string; plan: Plan, modifiedPlan: Omit<Plan, 'invalid'> };

export const CollapsableSyncPlan = ({ title, plan, modifiedPlan, children }: PropsWithChildren<Props>) => {
  const [showPlan, setShowPlan] = useState(true);

  return (
    <>
      <Box display="flex" alignItems="center">
        <IconButton onClick={() => setShowPlan(!showPlan)}>
          {showPlan ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
        </IconButton>
        <Typography variant="h6">{title}</Typography>
        <Box flexGrow={1} />
        <Tooltip title="Invalid">
          <Box display="flex" sx={{ mr: 2, color: 'orange', alignItems: 'center' }}>
            <WarningAmberIcon />
            <Typography variant="h6">{Object.keys(plan.invalid ?? {}).length}</Typography>
          </Box>
        </Tooltip>
        <Tooltip title="Creates">
          <Box display="flex" sx={{ mr: 2, color: 'green', alignItems: 'center', fontSize: 30 }}>
            <AddIcon />
            {modifiedPlan.create.length}&frasl;{plan.create.length}
          </Box>
        </Tooltip>
        <Tooltip title="Updates">
          <Box display="flex" sx={{ mr: 2, color: 'blue', alignItems: 'center', fontSize: 30 }}>
            <EditIcon />
            {modifiedPlan.update.length}&frasl;{plan.update.length}
          </Box>
        </Tooltip>
        <Tooltip title="Deletes">
          <Box display="flex" sx={{ mr: 2, color: 'red', alignItems: 'center', fontSize: 30 }}>
            <RemoveIcon />
            {modifiedPlan.delete.length}&frasl;{plan.delete.length}
          </Box>
        </Tooltip>
      </Box>
      <Collapse in={showPlan} sx={{ pl: '2.5em' }}>
        {children}
      </Collapse>
      <Divider sx={{ mt: '1rem', mb: '1rem' }} />
    </>
  );
};
